export const ENTITY_NAME = 'CODE_'
export const CODE_ENUM = 'CODE_ENUM_'
export const CODE_VALUE = 'CODE_VALUE'
